import customSelect from 'custom-select';

document.addEventListener('DOMContentLoaded', function() {

    const cars = document.getElementById('cars');
	let data = [];

	const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
        if(!accumulator.find(obj => obj[prop] === currentValue[prop])){
            accumulator.push(currentValue);
        }
        return accumulator;
    }, [])

    const loadDataFromFile = function(arg) {

        const _body = document.getElementById('body'),
              _size = document.getElementById('size'),
              _model = document.getElementById('model'),
              _engine = document.getElementById('engine'),
              _button = cars.getElementsByTagName('button')[0];

        let activeBody = _body.options[_body.selectedIndex].value;
        let activeSize = _size.options[_size.selectedIndex].value;
        let activeModel = _model.options[_model.selectedIndex].value;
        let data_filtered;

        const initCustomSelect = function() {

            const select = document.getElementsByTagName('select');

            for (let i = 0; i < window.cstSel.length; i++) {
                window.cstSel[i].destroy();
            }

                window.cstSel = customSelect(select);

                for (let i = 0; i < select.length; i ++) {
                    cstSel[i].container.addEventListener('custom-select:open', (e) => {
                        e.target.parentNode.style.position = 'relative';
                        e.target.parentNode.style.zIndex = '5';
                    });

                    cstSel[i].container.addEventListener('custom-select:close', (e) => {
                        e.target.parentNode.removeAttribute('style');
                    });
                }
        };

        const buildNextSelect = function(e) {

            // Get selected values
            activeBody = _body.options[_body.selectedIndex].value;
            activeSize = _size.options[_size.selectedIndex].value;
            activeModel = _model.options[_model.selectedIndex].value;

            let nextSelect = e.currentTarget.parentNode.parentNode.nextElementSibling.getElementsByTagName('select')[0];

                if(nextSelect) {
                    build_select(nextSelect.id, e.target.value)

                } else {

                    data_filtered = data.filter(d =>
                                                d.body === String(activeBody) &&
                                                d.size === String(activeSize) &&
                                                d.model === String(activeModel) &&
                                                d.engine === String(e.target.value));

                    const openUrl = function() {
                        window.open(data_filtered[0].url, '_blank');
                    };

                    if (data_filtered[0] != undefined) {
                        _button.disabled = false;
                        _button.addEventListener('click', openUrl);
                    } else {
                        _button.disabled = true;
                        _button.removeEventListener('click', openUrl);
                    }
                }
        }

        const build_select = function(id, val) {

            const dropdown = document.getElementById(id);
            let option, without_duplicates, data_filtered;

            // Init and reset dropdowns
            // for (let i = 1; i < cars.getElementsByTagName('select').length; i++) {
            //     cars.getElementsByTagName('select')[i].disabled = true;
            // }

            dropdown.length = 1;
            dropdown.disabled = false;
            dropdown.selectedIndex = 0;

            // Filter
            if (id === 'size') {
                _button.disabled = true;
                _engine.disabled = true;
                _model.disabled = true;

                data_filtered = data.filter(d =>
                                                d.body === String(val));

            } else if (id === 'model') {
                _engine.disabled = true;
                data_filtered = data.filter(d =>
                                                d.body === String(activeBody) &&
                                                d.size === String(activeSize));

            } else if (id === 'engine') {
                data_filtered = data.filter(d =>
                                                d.body === String(activeBody) &&
                                                d.size === String(activeSize) &&
                                                d.model === String(activeModel));
            }

            if (id === 'body') {
                without_duplicates = removeDuplicatesFromArrayByProperty(data, String(id));
                without_duplicates.sort((a, b) => a.body.localeCompare(b.body))
               // _button.removeEventListener('click', openUrl);
            } else {
                without_duplicates = removeDuplicatesFromArrayByProperty(data_filtered, String(id));
            }

            // Create Options
            for (let i = 0; i < without_duplicates.length; i++) {
                option = document.createElement('option');
                option.text = without_duplicates[i][id];
                option.value = without_duplicates[i][id];
                dropdown.add(option);
            }

            document.getElementById(id).addEventListener('change', buildNextSelect);

            initCustomSelect();
        };


        let request = new XMLHttpRequest();

        request.open('GET', arg, true);
        request.send(null);
        request.onreadystatechange = function() {
            if (request.readyState == 4) {
                if (request.status == 200) {
                    data = JSON.parse(request.responseText);
                    build_select('body');
                } else {
                    console.log(request.status, request.statusText);
                }
            }
        };
    };

    const init = function() {
        loadDataFromFile(cars.dataset.json);
    }

    cars ? init() : false;

}, false);
